import appData from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';

const fetchVideos = async data => {
  return await GetData.callAPI(`${appData.backend_api}/exams/cfa/videos/all-videos`, data);
};
const fetchLastViewedVideo = async (data = {}) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/cfa/videos/last-video-viewed`, {...data,});
};
module.exports = {
  fetchVideos,
  fetchLastViewedVideo,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Videos/ApiService.js